import styled from 'styled-components';
const S = {};

S.Datepicker = styled.div`
    display: flex;
    border: none;
`;

export default S;